import { useState } from 'react';
import { resolveMediaUrl } from '../utils/mediaUrl';

/**
 * Renders an image with a loading placeholder (moving dots) until the image has loaded.
 * Use for item images so the UI appears quickly and images fill in as they load.
 */
export default function ImageWithPlaceholder({ src, alt = '', className = '', containerClassName = '' }) {
  const [loaded, setLoaded] = useState(false);
  const resolvedSrc = resolveMediaUrl(src);

  if (!resolvedSrc) {
    return (
      <div className={`flex items-center justify-center bg-slate-200 dark:bg-slate-700 ${containerClassName}`}>
        <div className="flex gap-1">
          <span className="w-2 h-2 rounded-full bg-slate-400 dark:bg-slate-500 animate-bounce [animation-delay:0ms]" />
          <span className="w-2 h-2 rounded-full bg-slate-400 dark:bg-slate-500 animate-bounce [animation-delay:150ms]" />
          <span className="w-2 h-2 rounded-full bg-slate-400 dark:bg-slate-500 animate-bounce [animation-delay:300ms]" />
        </div>
      </div>
    );
  }

  return (
    <div className={containerClassName || 'relative'}>
      {!loaded && (
        <div
          className="absolute inset-0 flex items-center justify-center bg-slate-200 dark:bg-slate-700"
          aria-hidden="true"
        >
          <div className="flex gap-1">
            <span className="w-2 h-2 rounded-full bg-slate-400 dark:bg-slate-500 animate-bounce [animation-delay:0ms]" />
            <span className="w-2 h-2 rounded-full bg-slate-400 dark:bg-slate-500 animate-bounce [animation-delay:150ms]" />
            <span className="w-2 h-2 rounded-full bg-slate-400 dark:bg-slate-500 animate-bounce [animation-delay:300ms]" />
          </div>
        </div>
      )}
      <img
        src={resolvedSrc}
        alt={alt}
        referrerPolicy="no-referrer"
        className={`${className} ${!loaded ? 'opacity-0' : 'opacity-100'} transition-opacity duration-200`}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
      />
    </div>
  );
}
